<mat-stepper
  orientation="vertical"
  #stepper
  (selectionChange)="getStageNotes($event)">
  <ng-template matStepperIcon="edit">
    <mat-icon>check</mat-icon>
  </ng-template>
  @for (stage of stagesList;track stage) {
  <mat-step
    [completed]="stage.Completed"
    [aria-labelledby]="stage.Completed ? 'completed' : 'uncompleted'">
    <ng-template matStepLabel>
      <span> {{stage.name}}</span>
    </ng-template>
    <ng-template matStepContent>
      @if(stageNote?.length > 0){
      <!-- Approval Statuses -->
      @for (item of stageNote; track item) {
      <div class="note-wrapper d-flex my-3">
        <div class="highlighted highlighted-{{item.status?.id}} px-2"></div>
        <div class="mx-3 py-4 main-content">
          <div class="row">
            <div class="col-md-12">
              <p class="main-title">{{ 'Note' | translate}}</p>
              <span class="note-text">{{item.notes}}</span>
            </div>
            <div class="col-md-12 note-details">
              @if(item?.status?.id === 3){
              <span>{{ 'Approved-By' | translate}} : </span>
              }@else{
              <span>{{ 'Rejected-By' | translate}} : </span>
              }
              <span>{{item.approveRejectBy}} </span>
              <span class="mx-2"> {{ "At" | translate }} </span>
              <span
                >{{item.approveRejectDate | date: 'h.mm a , d MMMM y':' ':
                (currentLanguage === 'ar' ? 'ar' : 'en-US')}}</span
              >
            </div>
          </div>
        </div>
      </div>
      } }@else{
      <div class="my-4">
        <span class="msg-no-approvals">{{"No-Approvals"| translate}}</span>
      </div>
      }
    </ng-template>
  </mat-step>
  }
</mat-stepper>
